/*
 * ATTENTION: The "eval" devtool has been used (maybe by default in mode: "development").
 * This devtool is neither made for production nor for readable output files.
 * It uses "eval()" calls to create a separate source file in the browser devtools.
 * If you are trying to read the output file, select a different devtool (https://webpack.js.org/configuration/devtool/)
 * or disable the default devtool with "devtool: false".
 * If you are looking for production-ready output files, see mode: "production" (https://webpack.js.org/configuration/mode/).
 */
/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./assets/graditify_markets.module.js":
/*!********************************************!*\
  !*** ./assets/graditify_markets.module.js ***!
  \********************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

eval("{__webpack_require__.r(__webpack_exports__);\n/* harmony import */ var _graditify_markets_style_scss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./graditify_markets_style.scss */ \"./assets/graditify_markets_style.scss\");\n\n\n/**\n * Custom element of lenguage, country or currency selector\n */\nclass LocalizationForm extends HTMLElement {\n  constructor() {\n    super();\n    // ? selector dom\n    this.elements = {\n      input: this.querySelector('input[name=\"locale_code\"], input[name=\"country_code\"]'),\n      button: this.querySelector('button'),\n      panel: this.querySelector('.disclosure__list-wrapper')\n    };\n    this.elements.button.addEventListener('click', this.openSelector.bind(this));\n    this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));\n    this.addEventListener('keyup', this.onContainerKeyUp.bind(this));\n    this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));\n  }\n\n  // ? event focusout now closed panel\n  hidePanel() {\n    this.elements.button.setAttribute('aria-expanded', 'false');\n    this.elements.panel.classList.remove('active');\n    setTimeout(() => this.elements.panel.setAttribute('hidden', true), 300);\n  }\n\n  // ? press key space close panel control and focus button current\n  onContainerKeyUp(event) {\n    if (event.code.toUpperCase() !== 'ESCAPE') return;\n    this.hidePanel();\n    this.elements.button.focus();\n  }\n\n  // ? selected item on panel and send form with selection\n  onItemClick(event) {\n    event.preventDefault();\n    const form = this.querySelector('form');\n    this.elements.input.value = event.currentTarget.dataset.value;\n    if (form) form.submit();\n  }\n\n  // ? open select list country and language\n  openSelector() {\n    const isAttributeHidden = this.elements.panel.getAttribute('hidden');\n    this.elements.button.focus();\n    this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());\n    if (isAttributeHidden === '' || isAttributeHidden === 'true') {\n      this.elements.panel.toggleAttribute('hidden');\n      setTimeout(() => this.elements.panel.classList.add('active'), 10);\n    } else {\n      this.elements.panel.classList.remove('active');\n      setTimeout(() => this.elements.panel.toggleAttribute('hidden'), 300);\n    }\n  }\n\n  // ? closed list if is open\n  closeSelector(event) {\n    const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';\n    if (event.relatedTarget === null || shouldClose) {\n      this.hidePanel();\n    }\n  }\n}\ncustomElements.define('localization-form', LocalizationForm);\n\n//# sourceURL=webpack://theme-base-shopify/./assets/graditify_markets.module.js?\n}");

/***/ }),

/***/ "./assets/graditify_markets_style.scss":
/*!*********************************************!*\
  !*** ./assets/graditify_markets_style.scss ***!
  \*********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

eval("{__webpack_require__.r(__webpack_exports__);\n// extracted by mini-css-extract-plugin\n\n\n//# sourceURL=webpack://theme-base-shopify/./assets/graditify_markets_style.scss?\n}");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module can't be inlined because the eval devtool is used.
/******/ 	var __webpack_exports__ = __webpack_require__("./assets/graditify_markets.module.js");
/******/ 	
/******/ })()
;